import type {
  ImageElementDto,
  RectangleElementDto,
  VideoElementDto,
} from "@repo/api/overlays";
import type { Box, Resolution } from "@/features/Editor/Canvas/canvas-geometry";

// Images and videos cover the canvas keeping their aspect ratio; rectangles fill it.
export function getFullscreenBox(
  element: ImageElementDto | VideoElementDto | RectangleElementDto,
  resolution: Resolution,
): Box {
  if (element.type === "RECTANGLE") {
    return { x: 0, y: 0, w: resolution.width, h: resolution.height };
  }

  const { w, h } = element.size;
  const scale = Math.max(resolution.width / w, resolution.height / h);

  const fullscreenW = Math.round(w * scale);
  const fullscreenH = Math.round(h * scale);

  return {
    x: Math.round((resolution.width - fullscreenW) / 2),
    y: Math.round((resolution.height - fullscreenH) / 2),
    w: fullscreenW,
    h: fullscreenH,
  };
}
